import * as Cesium from 'cesium';

export function getAngleOfFeature(geometry: any): number {
  try {
    let coords;

    if (geometry.type === 'LineString' || geometry.type === 'MultiLineString') {
      coords = geometry.type === 'MultiLineString' ? geometry.coordinates[0] : geometry.coordinates;
    } else if (geometry.type === 'Polygon') {
      coords = geometry.coordinates[0]; // First ring of polygon
    } else if (geometry.type === 'MultiPolygon') {
      coords = geometry.coordinates[0][0]; // First ring of first polygon
    } else if (geometry.type === 'Point') {
      return 0; // Points don't have an angle
    } else {
      return 0;
    }

    // Need at least 2 points to calculate angle
    if (!coords || coords.length < 2) return 0;

    const [x1, y1] = coords[0];
    const [x2, y2] = coords[1];

    // Calculate angle in radians
    return Math.atan2(y2 - y1, x2 - x1);
  } catch (error) {
    console.error('Error calculating feature angle:', error);
    return 0;
  }
}

export function getLabelPosition(geometry: any, labelPosition: string): Cesium.Cartesian3 {
  try {
    let lon = 0,
      lat = 0;

    if (geometry.type === 'Point') {
      [lon, lat] = geometry.coordinates;
    } else if (geometry.type === 'LineString' || geometry.type === 'MultiLineString') {
      const coords = geometry.type === 'MultiLineString' ? geometry.coordinates[0] : geometry.coordinates;
      const midIdx = Math.floor(coords.length / 2);
      [lon, lat] = coords[midIdx];
    } else if (geometry.type === 'MultiPoint') {
      const coords = geometry.coordinates;
      // Center point of the line
      const midIdx = Math.floor(coords.length / 2);
      [lon, lat] = coords[midIdx];
    } else if (geometry.type === 'Polygon') {
      const coords = geometry.coordinates[0];
      // Compute centroid
      const lons = coords.map((c: number[]) => c[0]);
      const lats = coords.map((c: number[]) => c[1]);
      lon = (Math.min(...lons) + Math.max(...lons)) / 2;
      lat = (Math.min(...lats) + Math.max(...lats)) / 2;
    } else if (geometry.type === 'MultiPolygon') {
      const coords = geometry.coordinates?.[0]?.[0] ?? [[0, 0]];
      const lons = coords.map((c: number[]) => c[0]);
      const lats = coords.map((c: number[]) => c[1]);
      lon = (Math.min(...lons) + Math.max(...lons)) / 2;
      lat = (Math.min(...lats) + Math.max(...lats)) / 2;
    }

    // Compute base position
    let position = Cesium.Cartesian3.fromDegrees(lon, lat);

    // Apply a small offset (in meters) depending on dropdown selection
    const offsetMeters = 30;
    if (labelPosition.includes('offset')) {
      const heading = geometry.type === 'LineString' || geometry.type === 'MultiLineString' ? getAngleOfFeature(geometry) : 0;
      const localOffset = Cesium.Cartesian3.fromDegrees(
        lon + (offsetMeters / 111320) * Math.cos(heading),
        lat + (offsetMeters / 110540) * Math.sin(heading),
      );
      position = localOffset;
    }

    return position;
  } catch (err) {
    console.error('Error computing label position:', err);
    return Cesium.Cartesian3.fromDegrees(0, 0);
  }
}
